import { render, staticRenderFns } from "./FirstDraftModal.vue?vue&type=template&id=649060cf&scoped=true&"
import script from "./FirstDraftModal.vue?vue&type=script&lang=js&"
export * from "./FirstDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./FirstDraftModal.vue?vue&type=style&index=0&id=649060cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649060cf",
  null
  
)

export default component.exports